var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import formatLinks from '../../../../utilites/formatLinks';
export var MarkDownA = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var newChildren = children === null || children === void 0 ? void 0 : children.filter(function (i) { return i !== '\n'; });
    //   const href = formatLinks(props.href)
    //   console.log(props.node.properties)
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { href: props.node.properties.href, target: props.node.properties.target }, newChildren)));
};
//# sourceMappingURL=MarkDownA.js.mapvar __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import formatLinks from '../../../../utilites/formatLinks';
export var MarkDownA = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var newChildren = children === null || children === void 0 ? void 0 : children.filter(function (i) { return i !== '\n'; });
    //   const href = formatLinks(props.href)
    //   console.log(props.node.properties)
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { href: props.node.properties.href, target: props.node.properties.target }, newChildren)));
};
//# sourceMappingURL=MarkDownA.js.map